import React from "react";
import { useTranslation } from "react-i18next";
import underlineimage from "../assets/images/title-shape.png";
import frnbbg from "../assets/images/gaming-stats-bg.png";

import enterleague from "../assets/images/sportsdraft/howanauctionworks/enteraleague.jpg";
import bid from "../assets/images/sportsdraft/howanauctionworks/bidsofplayers.jpg";
import check from "../assets/images/sportsdraft/howanauctionworks/checkyoursquad.jpg";
import view from "../assets/images/sportsdraft/howanauctionworks/viewotherteams.jpg";
import automated from "../assets/images/sportsdraft/howanauctionworks/autoscoring.jpg";

interface GameItem {
  title: string;
  subtitle: string;
  image: string;
}

const AuctionGamePlay: React.FC = () => {
  const { t } = useTranslation();

  const gameData: GameItem[] = [
    { title: t("auction.enter"), subtitle: t("auction.league"), image: enterleague },
    { title: t("auction.bid"), subtitle: t("auction.players"), image: bid },
    { title: t("auction.check"), subtitle: t("auction.squad"), image: check },
    { title: t("auction.view"), subtitle: t("auction.teams"), image: view },
    { title: t("auction.automated"), subtitle: t("auction.scoring"), image: automated }
  ];

  return (
    <div
      className="relative pt-16 px-4 overflow-hidden bg-[#070b28] pb-[100px] bg-no-repeat bg-contain bg-bottom"
      style={{ backgroundImage: `url(${frnbbg})` }}
    >
      <div className="flex justify-center">
        <h2 className="text-[48px] font-oswald font-extrabold text-[#ffffff]">
          {t("auction.title")}
        </h2>
      </div>

      <img
        src={underlineimage}
        alt="underline"
        className="mx-auto mt-2 mb-6 w-[120px] h-auto"
      />
      <div className="mx-auto max-w-[1140px]">
        <div className="grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6">
          {gameData.map((game, index) => (
            <div
              key={index}
              className="h-[325px] relative border rounded-xl overflow-hidden text-center text-white transition-transform duration-300 bg-hover"
            >
              <div className="h-full flex items-center justify-center">
                <img
                  src={game.image}
                  alt={game.title}
                  className="h-full w-full scale-100 object-cover"
                />
              </div>
              <div className="absolute bottom-5 left-8 px-2 py-3 text-left font-proxima">
                <h5 className="text-lg font-semibold uppercase">{game.title}</h5>
                <span className="block text-xs tracking-wide uppercase text-white mt-1">
                  {game.subtitle}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AuctionGamePlay;
